import PropTypes from 'prop-types'
import React, { useState } from 'react'
import TriviaGameAwards from './TriviaGameAwards'
import TriviaGameQuestions from './TriviaGameQuestions'
import TriviaGameTimerScore from './TriviaGameTimerScore'

const TriviaGame = ({
  data,
  docsHidden,
  duration,
  max,
  setDocsHidden,
  title,
}) => {
  const [playing, setPlaying] = useState(true)
  const [score, setScore] = useState(0)
  const [timer, setTimer] = useState(duration)

  const reset = () => {
    setPlaying(true)
    setScore(0)
    setTimer(duration)
  }

  return (
    <>
      <div className="contain">
        <TriviaGameTimerScore
          setTimer={setTimer}
          score={score}
          title={title}
          timer={timer}
        />
        {playing ? (
          <TriviaGameQuestions
            data={data}
            docsHidden={docsHidden}
            max={max}
            ppq={1}
            reset={reset}
            setDocsHidden={setDocsHidden}
            setPlaying={setPlaying}
            setScore={setScore}
            score={score}
          />
        ) : (
          <TriviaGameAwards reset={reset} score={score} />
        )}
      </div>
    </>
  )
}

TriviaGame.defaultProps = {
  duration: 60,
  max: 10,
  ppq: 1,
  title: 'Quiz',
}

TriviaGame.propTypes = {
  data: PropTypes.string.isRequired,
  docsHidden: PropTypes.bool,
  duration: PropTypes.number,
  instructions: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  max: PropTypes.number,
  ppq: PropTypes.number,
  setDocsHidden: PropTypes.func,
  title: PropTypes.string,
}

export default TriviaGame
